import { OnInit, OnDestroy, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RecordService } from 'modules/core/services/record.service';
import { DialogService } from 'modules/shared/components/dialog/dialog.service';
import { SnackbarService } from 'app/services/snackbar.service';
import { CrpRoleDataSource } from './crp-role.data-source';
var CrpRoleComponent = /** @class */ (function () {
    function CrpRoleComponent(recordService, store, formBuilder, dialog, snackBar, datePipe, cdRef) {
        this.recordService = recordService;
        this.store = store;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.snackBar = snackBar;
        this.datePipe = datePipe;
        this.cdRef = cdRef;
        this.unsubscribe$ = new Subject();
        this.displayedColumns = ['role', 'dateAppointed', 'dateResigned', 'actions'];
        this.change = new EventEmitter();
        this.rolesList = [];
        this.crpRoles = [];
        this.unsubscribe = new Subject();
        this.addCrpMode = true;
        this.maxDateAppointed = new Date();
        this.dataSource = new MatTableDataSource(this.crpRoles);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }
    Object.defineProperty(CrpRoleComponent.prototype, "crpId", {
        get: function () {
            return this._crpId;
        },
        set: function (value) {
            this._crpId = value;
            if (this.dataSource) {
                this.dataSource.disconnect(null);
            }
            this.dataSource = value ? new CrpRoleDataSource(this.store, value) : new MatTableDataSource(this.crpRoles);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.reload();
        },
        enumerable: true,
        configurable: true
    });
    CrpRoleComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addCrpMode = true;
        this.buildForm();
        this.recordService.getRoles()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (res) {
            _this.rolesList = res;
        });
    };
    CrpRoleComponent.prototype.buildForm = function () {
        var _this = this;
        this.form = this.formBuilder.group({
            role: [, Validators.required],
            otherRole: [],
            dateAppointed: [],
            dateResigned: []
        });
        this.form.get('role').valueChanges.subscribe(function (role) {
            if (role && (role.toLowerCase() === 'please specify')) {
                _this.form.get('otherRole').setValidators(Validators.required);
            }
            else {
                _this.form.get('otherRole').clearValidators();
            }
            _this.form.get('otherRole').updateValueAndValidity();
        });
        this.form.get('dateAppointed').valueChanges.subscribe(function (dateAppointed) {
            _this.minDateResigned = dateAppointed;
        });
    };
    CrpRoleComponent.prototype.reload = function () {
        if (this.form) {
            this.form.reset();
        }
        this.currentRole = null;
        this.currentIndex = null;
        if (this.crpId) {
            this.dataSource.loadCrps();
        }
        else {
            this.dataSource.data = this.crpRoles;
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        }
    };
    /**
     * @method checkOtherRoleValue
     * Check if the role value is customized and set accordingly
     */
    CrpRoleComponent.prototype.checkOtherRoleValue = function () {
        var allRoleValues = [];
        this.rolesList.forEach(function (roleCategory) {
            allRoleValues = allRoleValues.concat(roleCategory.roles);
        });
        var isOtherRole = this.currentRole.role &&
            (this.currentRole.role.toLowerCase() === 'please specify' ||
                !~allRoleValues.indexOf(this.currentRole.role));
        if (isOtherRole) {
            this.form.patchValue({
                'role': 'PLEASE SPECIFY',
                'otherRole': this.currentRole.role
            });
        }
    };
    CrpRoleComponent.prototype.editRole = function (role, index) {
        if (!this.crpId) {
            this.currentIndex = index;
        }
        this.currentRole = role;
        this.addCrpMode = false;
        this.form.patchValue(role);
        this.checkOtherRoleValue();
    };
    CrpRoleComponent.prototype.deleteRole = function (role, index) {
        var _this = this;
        if (this.crpId) {
            // in edit page should check if this is the last in role list before delete
            if (this.dataSource.getDataSourceLength() > 1) {
                this.dialog.confirm('Are you sure you want to delete?', 'ROLE DELETE')
                    .subscribe(function (res) {
                    if (res === 'submit') {
                        _this.change.emit({
                            type: 'DELETE',
                            role: role
                        });
                    }
                });
            }
            else {
                this.snackBar.error("A CRP needs to have at least one role");
            }
        }
        else {
            this.dialog.confirm('Are you sure you want to delete?', 'ROLE DELETE')
                .subscribe(function (res) {
                if (res === 'submit') {
                    _this.crpRoles.splice(index, 1);
                    _this.reload();
                }
            });
        }
    };
    CrpRoleComponent.prototype.getCrpRoles = function () {
        this.cdRef.detectChanges();
        return this.crpRoles;
    };
    CrpRoleComponent.prototype.submit = function () {
        if (this.form.valid) {
            if (this.form.get('role').value.toLowerCase() === 'please specify') {
                this.form.get('role').setValue(this.form.get('otherRole').value);
            }
            if (this.crpId) {
                if (!this.currentRole || !this.currentRole.id) {
                    this.currentRole = {
                        role: this.form.get('role').value,
                        dateAppointed: this.datePipe.transform(this.form.get('dateAppointed').value, 'yyyy-MM-dd'),
                        dateResigned: this.datePipe.transform(this.form.get('dateResigned').value, 'yyyy-MM-dd')
                    };
                    this.currentRole.crp = this.crpId;
                    this.change.emit({
                        type: 'ADD',
                        role: this.currentRole
                    });
                }
                else {
                    this.currentRole = Object.assign(this.currentRole, {
                        role: this.form.get('role').value,
                        dateAppointed: this.datePipe.transform(this.form.get('dateAppointed').value, 'yyyy-MM-dd'),
                        dateResigned: this.datePipe.transform(this.form.get('dateResigned').value, 'yyyy-MM-dd')
                    });
                    this.change.emit({
                        type: 'EDIT',
                        role: this.currentRole
                    });
                }
            }
            else {
                if (this.currentIndex !== null && this.currentIndex >= 0) {
                    this.crpRoles[this.currentIndex] = this.form.value;
                }
                else {
                    this.currentRole = {
                        role: this.form.get('role').value,
                        dateAppointed: this.datePipe.transform(this.form.get('dateAppointed').value, 'yyyy-MM-dd'),
                        dateResigned: this.datePipe.transform(this.form.get('dateResigned').value, 'yyyy-MM-dd')
                    };
                    this.crpRoles.unshift(Object.assign({}, this.currentRole));
                }
                this.reload();
            }
            this.currentRole = null;
            this.addCrpMode = true;
        }
    };
    CrpRoleComponent.prototype.cancelAddRole = function () {
        this.currentRole = null;
        this.addCrpMode = true;
        this.reload();
    };
    CrpRoleComponent.prototype.clearFormAndTable = function () {
        this.crpRoles = [];
        this.reload();
    };
    /**
     * @method setSelectedRole
     * Set selected role value
     */
    CrpRoleComponent.prototype.setSelectedRole = function (role) {
        this.form.get('role').setValue(role);
        this.form.markAsDirty();
    };
    CrpRoleComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    };
    return CrpRoleComponent;
}());
export { CrpRoleComponent };
